import { Component, EventEmitter, HostListener, Input, Output } from "@angular/core";
import { NewDialogComponent } from "common/newdialog/dialog.component";
import { KeyboardService } from "common/keyboard.service";

@Component({
	selector: "stages-dialog-header",
	templateUrl: "./dialog-header.component.html",
	styleUrls: ["dialog-header.component.scss"],
})
export class DialogHeaderComponent {
	selectedLanguage: number = 0;

	@Input()
	languages?: string[];

	@Input()
	showCloseButton: boolean = true;

	@Output()
	readonly languageSelected = new EventEmitter<number>();

	constructor(private dialogComponent: NewDialogComponent, private readonly keyboardService: KeyboardService) {}

	isLanguageSelected(index: number): boolean {
		return this.selectedLanguage === index;
	}

	selectLanguage(index: number): void {
		this.selectedLanguage = index;
		this.languageSelected.emit(this.selectedLanguage);
	}

	close(): void {
		this.dialogComponent.close();
	}

	@HostListener("document:keydown", ["$event"])
	onKeyDown(event: KeyboardEvent): void {
		if (this.keyboardService.isEscapeKeyPressed(event)) {
			this.close();
		}
	}
}
